module.exports = __webpack_public_path__ + "img/icon-qrcode@3x.9df0ab75.png";